import { IncrediChartBar, IncrediChartLine, IncrediChartHeatmap, useIncrediDialog } from 'incredi-ui';
import { ComputedRef } from 'vue';
import moment, { unitOfTime } from 'moment';
import { formatNumber } from '@/services/utils';

export const dataZoomSliderOff = [
  {
    type: 'inside',
    startValue: 0,
    endValue: 120,
    maxValueSpan: 120,
  },
];
export const useDashboardChartUtils = () => {
  const dialog = useIncrediDialog();

  const options = {
    toolbox: {
      feature: {
        maximize: ({
          chartId,
          chartOptions,
          componentInstance,
        }: {
          chartId: string;
          chartOptions: ComputedRef<
            InstanceType<typeof IncrediChartBar>['$props'] | ComputedRef<InstanceType<typeof IncrediChartLine>['$props']> | ComputedRef<InstanceType<typeof IncrediChartHeatmap>['$props']>
          >;
          componentInstance: InstanceType<any>;
        }) => ({
          show: true,
          title: '',
          iconStyle: {
            color: '#525765', // Set the fill color here
            borderWidth: 0, // Optional: Set the stroke width here
          },
          emphasis: {
            iconStyle: {
              color: '#525765', // Set the fill color here
              borderWidth: 0, // Optional: Set the stroke width here
            },
          },
          icon: 'path://M14.5495 4.16545H13.2979C12.8377 4.16545 12.4646 3.79235 12.4646 3.33211C12.4646 2.87188 12.8377 2.49878 13.2979 2.49878H16.6312C17.0915 2.49878 17.4646 2.87188 17.4646 3.33211V6.66545C17.4646 7.12568 17.0915 7.49878 16.6312 7.49878C16.171 7.49878 15.7979 7.12568 15.7979 6.66545V5.2741L12.0898 8.98222C11.7643 9.30766 11.2367 9.30766 10.9113 8.98222C10.5858 8.65678 10.5858 8.12914 10.9113 7.80371L14.5495 4.16545ZM5.45056 15.8346H6.70219C7.16243 15.8346 7.53552 16.2077 7.53552 16.668C7.53552 17.1282 7.16243 17.5013 6.70219 17.5013H3.36886C2.90862 17.5013 2.53552 17.1282 2.53552 16.668V13.3346C2.53552 12.8744 2.90862 12.5013 3.36886 12.5013C3.82909 12.5013 4.20219 12.8744 4.20219 13.3346L4.20219 14.726L7.91031 11.0179C8.23575 10.6924 8.76339 10.6924 9.08882 11.0179C9.41426 11.3433 9.41426 11.8709 9.08882 12.1964L5.45056 15.8346Z',
          onclick() {
            dialog?.open(
              `${chartId}-dialog`,
              componentInstance,
              {
                chartOptions: {
                  ...chartOptions.value,
                  chartId: `${chartId}-dialog`,
                  options: {
                    ...((chartOptions.value as any).options || {}),
                    dataZoom: undefined,
                    toolbox: {
                      feature: {
                        myTool1: {
                          show: true,
                          title: '',
                          iconStyle: {
                            color: '#525765', // Set the fill color here
                            borderWidth: 0, // Optional: Set the stroke width here
                          },
                          emphasis: {
                            iconStyle: {
                              color: '#525765', // Set the fill color here
                              borderWidth: 0, // Optional: Set the stroke width here
                            },
                          },
                          icon: 'path://M11.5817 5.56036H12.8333C13.2936 5.56036 13.6667 5.93346 13.6667 6.3937C13.6667 6.85393 13.2936 7.22703 12.8333 7.22703H9.50002C9.03978 7.22703 8.66668 6.85393 8.66668 6.3937V3.06036C8.66668 2.60013 9.03978 2.22703 9.50002 2.22703C9.96025 2.22703 10.3333 2.60013 10.3333 3.06036V4.45171L14.0415 0.743589C14.3669 0.418152 14.8945 0.418153 15.22 0.743589C15.5454 1.06903 15.5454 1.59666 15.22 1.9221L11.5817 5.56036ZM4.41798 10.4399H3.16636C2.70612 10.4399 2.33302 10.0668 2.33302 9.6066C2.33302 9.14636 2.70612 8.77327 3.16636 8.77327H6.49969C6.95993 8.77327 7.33302 9.14636 7.33302 9.6066L7.33302 12.9399C7.33302 13.4002 6.95993 13.7733 6.49969 13.7733C6.03945 13.7733 5.66636 13.4002 5.66636 12.9399V11.5486L1.95823 15.2567C1.6328 15.5821 1.10516 15.5821 0.779722 15.2567C0.454286 14.9313 0.454285 14.4036 0.779722 14.0782L4.41798 10.4399Z',
                          onclick() {
                            dialog?.close(`${chartId}-dialog`);
                          },
                        },
                      },
                    },
                  },
                  height: '80vh',
                  width: '80vw',
                },
              },
              {
                closeOnClickOutside: true,
              },
            );
          },
        }),
      },
    },
  };
  return { options };
};

export const convertBaseTimeToSSMMHH = (baseTime: number, unit: unitOfTime.DurationConstructor = 'seconds', hideSeconds = false) => {
  if (!baseTime) {
    return '0';
  }
  const duration = moment.duration(baseTime, unit);
  const hours = Math.floor(duration.asHours());
  const minutes = duration.minutes();
  const seconds = duration.seconds();

  let formatted = '';
  if (hours > 0) {
    formatted += `${formatNumber(hours)}h `;
  }
  if (minutes > 0 || hours > 0) {
    formatted += `${minutes}m `;
  }
  if ((!hideSeconds || seconds < 60) && (seconds > 0 || minutes > 0 || hours > 0)) {
    formatted += `${seconds}s`;
  }

  return formatted.trim();
};

export const openLearnMoreLink = () => {
  window.open('https://www.incredibuild.com/product/build-cache', '_blank');
};

export const getNoDataForBuildCacheCharts = (hasBuildCacheInLicense: boolean, hasNoDataInChart: boolean): 'buildCacheLicenseeNeeded' | 'noDataFound' | undefined => {
  if (hasNoDataInChart) {
    return hasBuildCacheInLicense ? 'noDataFound' : 'buildCacheLicenseeNeeded';
  }
  return undefined;
};

export const convertChartUnitsFromSeconds = <T extends unknown[]>(data: T, durationKeys: Partial<keyof T[number]>[]) => {
  const maxDuration = data.reduce((acc: number, item: any) => {
    let maxDurationItem = 0;
    durationKeys.forEach(key => {
      if (item[key] > maxDurationItem) maxDurationItem = item[key];
    });
    if (maxDurationItem > acc) return maxDurationItem;
    return acc;
  }, 0);

  let targetBaseTime: 'seconds' | 'minutes' | 'hours' = 'seconds';

  if (maxDuration > 10800) {
    targetBaseTime = 'hours';
  } else if (maxDuration > 180) {
    targetBaseTime = 'minutes';
  }
  if (targetBaseTime === 'seconds') return { convertedData: data, originData: data, unit: targetBaseTime };
  const convertedData = data.map((item: any) => {
    const newItem: any = { ...item };
    durationKeys.forEach((key: keyof typeof item) => {
      newItem[key] = moment.duration(item[key], 'seconds').as(targetBaseTime);
    });
    return newItem;
  }) as T;
  return {
    unit: targetBaseTime,
    convertedData,
    originData: data,
  };
};

export const fillChartWithEmptyData = <T extends any[]>(data: T, rangeDates: { from: number; to: number }): T => {
  if (!data || data.length === 0) return data;
  const newData = [...data];
  const from = moment(rangeDates.from);
  const to = moment(rangeDates.to);
  const diff = to.diff(from, 'days');
  for (let i = 0; i < diff; i++) {
    const date = from.clone().add(i, 'days').format('YYYY/MM/DD');
    const found = newData.find(item => item.date && moment(new Date(item?.date)).format('YYYY/MM/DD') === date);
    if (!found) {
      newData.push({
        date,
        ...Object.keys(newData[0]).reduce((acc, key) => {
          if (key === 'date' || key === '__typename') return acc;
          return { ...acc, [key]: 0 };
        }, {}),
      });
    }
  }
  return newData as T;
};

export const getAllDatesInRange = (from: number, to: number, day: 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday', time: string) => {
  // Create an array to store the matching dates
  const [hour, minutes] = time.split(':');

  const dates: { from: moment.Moment; to: moment.Moment }[] = [];

  // Create a moment instance for the start and end dates
  const startDate = moment(from).set({ hour: Number(hour), minutes: Number(minutes) });
  const endDate = moment(to).set({ hour: Number(hour), minutes: Number(minutes) });

  // Define a mapping from day names to moment.js day numbers (0 = Sunday, 6 = Saturday)
  const dayMapping = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  // Get the numeric representation of the day
  const dayNumber = dayMapping[day];

  // Iterate over each day in the range
  while (startDate.isBefore(endDate) || startDate.isSame(endDate)) {
    // Check if the current day matches the specified day
    if (startDate.day() === dayNumber) {
      // If it does, add it to the array
      dates.push({ from: startDate.clone(), to: startDate.clone().add(1, 'hours') });
    }

    // Move to the next day
    startDate.add(1, 'days');
  }

  return dates;
};
